import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip';
import {
  getScannerStatusByKey,
  ScannerStatusEnum
} from '../../../types/commonTypes';
import styles from './Status.css';

const Status = React.memo(({ status }) => {
  const statusInfo = getScannerStatusByKey(status);

  // Special case: if status is UNKNOWN, wrap label in tooltip showing the original status value
  const labelContent =
    statusInfo.key === ScannerStatusEnum.UNKNOWN.key ? (
      <Tooltip
        content={`Unknown status: ${status}`}
        position="top"
        testId="status-unknown-tooltip"
      >
        {statusInfo.label}
      </Tooltip>
    ) : (
      statusInfo.label
    );

  return (
    <div data-test-id="status-id" className={styles[statusInfo.cssStyle]}>
      {labelContent}
    </div>
  );
});

Status.propTypes = {
  status: PropTypes.string
};

export default Status;
